export const formField = [
  { label: '消息模板名称', prop: 'templateName', colNum: 6 },
  { label: '消息模板编码', prop: 'templateCode', colNum: 6 },
  { label: '触发条件名称', prop: 'sceneDesc', colNum: 6 },
  { label: '触发条件编码', prop: 'sceneCode', colNum: 6 },
  { label: '消息类型', prop: 'messageType', colNum: 6, slotName: 'messageTypeSlot' },
  { label: '状态', prop: 'isEnabled', colNum: 6, slotName: 'isEnabledTypeSlot' }
]
